import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "quick-range-buttons" }
const _hoisted_2 = { class: "quick-range-label" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('components.quickRange.label')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset) => {
      return (_openBlock(), _createElementBlock("button", {
        key: preset.key,
        type: "button",
        class: _normalizeClass(["btn btn-sm", { active: _ctx.activePreset === preset.key }]),
        onClick: ($event: any) => (_ctx.applyPreset(preset.key))
      }, _toDisplayString(_ctx.$t(preset.label)), 11, _hoisted_3))
    }), 128))
  ]))
}